export default __webpack_public_path__ + "static/ba-bfc061111b0689e3645f07b56841d010.svg";